<template>
    <div class="ah-page service-fee-statement">
        <div class="page-header bottom-margin">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1>勞報單管理</h1>
                    </div>
                    <div class="actions">
                        <el-button @click="onImport">批次匯入</el-button>
                        <el-button type="highlight" @click="onAdd">新增勞報單</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="ah-container">
            <div class="ah-panel">
                <div class="panel-body" style="padding-bottom: 0">
                    <div class="tool-block">
                        <el-form label-position="top" class="form">
                            <el-form-item label="付款期間">
                                <el-date-picker
                                    :default-time="['00:00:00', '23:59:59']"
                                    v-model="payDateRange"
                                    value-format="timestamp"
                                    type="daterange"
                                    range-separator="~"
                                    start-placeholder="開始日期"
                                    end-placeholder="結束日期"
                                    style="width: 100%"
                                    size="small"
                                    :clearable="true"
                                    :picker-options="datePickerOption"
                                    @change="updateData"
                                ></el-date-picker>
                            </el-form-item>
                            <el-form-item label="領款人">
                                <el-input v-model="queryParams.payee" style="width: 230px" size="small" placeholder="請輸入領款人" @keyup.enter.native="updateData(true)">
                                    <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer" @click="updateData(true)" />
                                </el-input>
                            </el-form-item>
                            <el-form-item label="摘要關鍵字">
                                <el-input v-model="queryParams.nam" style="width: 230px" size="small" placeholder="請輸入摘要" @keyup.enter.native="updateData(true)">
                                    <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer" @click="updateData(true)" />
                                </el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <div class="panel-body" style="padding-top: 15px">
                    <ahDataTable
                        tableKey="service-fee-data-table"
                        :columns="tableColumns"
                        :data="datas"
                        :showRefreshButton="true"
                        v-loading="isLoading"
                        @row-click="onRowClick"
                        @selection-change="onSelectionChange"
                        @refresh="updateData"
                    >
                        <template v-slot:top-left-actions>
                            <div style="display: flex; gap: 5px">
                                <el-tooltip class="item" effect="dark" placement="top" :manual="isTransformable">
                                    <template slot="content">
                                        <div v-if="selectedItems.length <= 0">請先勾選項目</div>
                                        <div v-else>不符合合併轉送條件：領款人、專案、所得類別、業別代號、幣別、付款方式，以上均需相同。</div>
                                    </template>
                                    <el-button size="mini" :disabled="!isTransformable" @click="onTransform">
                                        <span>合併轉送請款</span>
                                        <span v-if="selectedItems.length > 0">({{ selectedItems.length }})</span>
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="請先勾選項目" placement="top" :manual="selectedItems.length > 0">
                                    <el-button size="mini" :disabled="selectedItems.length <= 0" @click="onExportPdf">
                                        <span>匯出 PDF</span>
                                        <span v-if="selectedItems.length > 0">({{ selectedItems.length }})</span>
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    :content="selectedItems.length <= 0 ? '請先勾選「待請款」項目' : '含有非「待請款」的項目'"
                                    placement="top"
                                    :manual="isEnableBatchDelete"
                                >
                                    <el-button size="mini" :disabled="!isEnableBatchDelete" @click="onBatchDelete">
                                        <span>刪除</span>
                                        <span v-if="selectedItems.length > 0">({{ selectedItems.length }})</span>
                                    </el-button>
                                </el-tooltip>
                            </div>
                        </template>
                        <template v-slot:bottom-left-actions>
                            <div style="display: flex; gap: 5px; margin-top: 15px">
                                <el-tooltip class="item" effect="dark" :content="selectedItems.length <= 0 ? '請先勾選項目' : '未符合轉送條件'" placement="top" :manual="isTransformable">
                                    <el-button size="mini" :disabled="!isTransformable" @click="onTransform">
                                        <span>合併轉送請款</span>
                                        <span v-if="selectedItems.length > 0">({{ selectedItems.length }})</span>
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="請先勾選項目" placement="top" :manual="selectedItems.length > 0">
                                    <el-button size="mini" :disabled="selectedItems.length <= 0" @click="onExportPdf">
                                        <span>匯出 PDF</span>
                                        <span v-if="selectedItems.length > 0">({{ selectedItems.length }})</span>
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    :content="selectedItems.length <= 0 ? '請先勾選「待請款」項目' : '含有非「待請款」的項目'"
                                    placement="top"
                                    :manual="isEnableBatchDelete"
                                >
                                    <el-button size="mini" :disabled="!isEnableBatchDelete" @click="onBatchDelete">
                                        <span>刪除</span>
                                        <span v-if="selectedItems.length > 0">({{ selectedItems.length }})</span>
                                    </el-button>
                                </el-tooltip>
                            </div>
                        </template>
                        <template v-slot:top-right-actions>
                            <div class="ah-tabs" style="margin-bottom: 12px">
                                <div
                                    class="item status-label"
                                    :class="{
                                        'name-only': true,
                                        active: queryParams.status === null,
                                    }"
                                    @click="onChangeStatus(null)"
                                >
                                    <!-- <span class=""> -->
                                        <span class="name">全部</span>
                                        <span class="count">{{ countStatistic.totalCount }}</span>
                                    <!-- </span> -->
                                </div>
                                <div class="item" :class="{ active: queryParams.status === 3 }" @click="onChangeStatus(3)">
                                    <span class="name no-padding">
                                        <StatusLabel :statusNum="3" :count="countStatistic.waitForPayCount" />
                                    </span>
                                    <span class="total">
                                        <Money :v="amountStatistic.waitForPayAmount" round></Money>
                                    </span>
                                </div>
                                <div class="item" :class="{ active: queryParams.status === 4 }" @click="onChangeStatus(4)">
                                    <span class="name no-padding">
                                        <StatusLabel :statusNum="4" :count="countStatistic.payingCount" />
                                    </span>
                                    <span class="total">
                                        <Money :v="amountStatistic.payingAmount" round></Money>
                                    </span>
                                </div>
                                <div class="item" :class="{ active: queryParams.status === 5 }" @click="onChangeStatus(5)">
                                    <span class="name no-padding">
                                        <StatusLabel :statusNum="5" :count="countStatistic.confirmedCount" />
                                    </span>
                                    <span class="total">
                                        <Money :v="amountStatistic.confirmedAmount" round></Money>
                                    </span>
                                </div>
                                <div class="item" :class="{ active: queryParams.status === 7 }" @click="onChangeStatus(7)">
                                    <span class="name no-padding">
                                        <StatusLabel :statusNum="7" :count="countStatistic.rejectCount" />
                                    </span>
                                    <span class="total">
                                        <Money :v="amountStatistic.rejectAmount" round></Money>
                                    </span>
                                </div>
                            </div>
                        </template>
                        <template v-slot:systemNo="scope">
                            <div class="idx">{{ scope.row.systemNo }}</div>
                        </template>
                        <template v-slot:nam="scope">
                            <span class="type-tag primary" v-if="scope.row.toBeAddFile">待補證件</span>
                            {{ scope.row.nam }}
                        </template>
                        <template v-slot:status="scope">
                            <div><StatusLabel :statusNum="scope.row.status" /></div>
                        </template>
                        <template v-slot:projectNam="scope">
                            <div style="font-size: 9pt; color: #aaa">{{ scope.row.projectNam }}</div>
                        </template>
                        <template v-slot:typ="scope">
                            <div>{{ scope.row.typ === 1 ? "公司填寫" : "領款人填寫" }}</div>
                        </template>
                        <template v-slot:incomeType="scope">
                            <div style="font-size: 9.5pt">{{ getIncomeType(scope.row.incomeType) }}</div>
                        </template>
                        <template v-slot:serviceType="scope">
                            <span style="font-size: 9.5pt">{{ getServiceType(scope.row.serviceType) }}</span>
                        </template>
                        <template v-slot:payee="scope">
                            <div v-if="scope.row.personalOutsourcingSno === -1">（未填寫）</div>
                            <div v-else>{{ scope.row.payee }}</div>
                        </template>
                        <template v-slot:plannedPayDat="scope">
                            <div>
                                <template v-if="scope.row.status === 5 || scope.row.status === 6">
                                    <span style="color: #888; font-size: 10pt">{{ scope.row.pay_Dat | dateFormater("YYYY-MM-dd") }}</span>
                                </template>
                                <template v-else>
                                    <el-tooltip class="item" effect="dark" content="預計付款日期" placement="top">
                                        <span style="color: #888; font-size: 10pt; margin-right: 6px"><i class="el-icon-time" /></span>
                                    </el-tooltip>
                                    <span style="color: #888; font-size: 10pt">{{ scope.row.plannedPayDat | dateFormater("YYYY-MM-dd") }}</span>
                                </template>
                            </div>
                        </template>
                        <template v-slot:amt="scope">
                            <div>
                                <template v-if="scope.row.status === 5 || scope.row.status === 6">
                                    <el-tooltip class="item" effect="dark" content="現金付款" placement="top">
                                        <i v-if="scope.row.payWay == 1" class="el-icon-money" style="opacity: 0.6; margin-right: 8px"></i>
                                    </el-tooltip>
                                </template>
                                <template v-else>
                                    <el-tooltip class="item" effect="dark" content="現金付款（預計）" placement="top">
                                        <i v-if="scope.row.plannedPayWay == 1" class="el-icon-money" style="opacity: 0.6; margin-right: 8px"></i>
                                    </el-tooltip>
                                </template>
                                <Money :v="scope.row.amt" :precision="scope.row.cny === 'TWD' ? null : 4" />
                            </div>
                        </template>
                    </ahDataTable>
                    <div class="pagination">
                        <el-pagination
                            layout="prev, pager, next"
                            :page-size.sync="queryParams.PageSize"
                            :total.sync="totalDataCount"
                            :current-page.sync="queryParams.PageNum"
                            @current-change="updateData(false)"
                        >
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <DetailDialog :visible="detailDialog.visible" :sno="detailDialog.sno" @close="onDetailDialogClose" />
        <ExportPdfDialog ref="exportPdfDialog" :visible="exportPdfDialog.visible" @close="onExportPdfDialogClose" />
        <BatchImportDialog ref="batchImportDialog" :visible="batchImportDialog.visible" @close="onBatchImportDialogDialogClose" />
    </div>
</template>
<script>
import _ from 'lodash';
import moment from 'moment';
import DetailDialog from '@/components/dashboard/ServiceFeeStatement/DetailDialog.vue';
import ExportPdfDialog from '@/components/dashboard/ServiceFeeStatement/ExportPdf/ExportPdfDialog.vue';
import BatchImportDialog from '@/components/dashboard/ServiceFeeStatement/BatchImport/BatchImportDialog.vue';
import StatusLabel from '@/components/dashboard/ServiceFeeStatement/StatusLabel.vue';
import ahDataTable from '@/components/ui/ahDataTable.vue';
import {
    serviceTypeList, serviceType9AList, serviceType9BList, datePickerOption,
} from '@/assets/commonData/options';

export default {
    components: {
        DetailDialog,
        StatusLabel,
        ahDataTable,
        ExportPdfDialog,
        BatchImportDialog,
    },
    data() {
        return {
            isLoading: false,
            datePickerOption,
            payDateRange: [],
            queryParams: {
                payee: null,
                nam: null,
                status: null,
                PageSize: 25,
                PageNum: 1,
            },
            totalDataCount: 0,

            datas: [],
            amountStatistic: {},
            countStatistic: {},

            selectedItems: [],
            detailDialog: {
                visible: false,
                sno: null,
            },
            exportPdfDialog: {
                visible: false,
            },
            batchImportDialog: {
                visible: false,
            },
            tableColumns: {
                selection: {},
                index: {
                    label: '#',
                    start: 1,
                },
                systemNo: {
                    label: '系統編號',
                    width: 95,
                },
                status: {
                    label: '狀態',
                    width: 100,
                },
                nam: {
                    label: '勞務摘要',
                    disableHide: true,
                },
                projectNam: {
                    label: '專案',
                    width: 150,
                    showOverflowTooltip: true,
                },
                incomeType: {
                    label: '所得類別',
                    width: 80,
                },
                serviceType: {
                    label: '業別代號',
                    width: 100,
                    showOverflowTooltip: true,
                },
                payee: {
                    label: '領款人',
                    width: 110,
                },
                // typ: {
                //     label: '填單方式',
                //     width: 90,
                //     hideByDefault: true,
                // },
                crt_nam: {
                    label: '申請人',
                    width: 110,
                    hideByDefault: true,
                },
                plannedPayDat: {
                    label: '付款日期',
                    width: 140,
                },
                amt: {
                    label: '勞報單金額',
                    align: 'right',
                    width: 110,
                },
                cny: {
                    label: '幣別',
                    width: 60,
                },
            },
        };
    },
    computed: {
        isTransformable() {
            const IS_PAYEE_SAME = _.uniqBy(this.selectedItems, 'payee').length === 1;
            const IS_PROJECT_SAME = _.uniqBy(this.selectedItems, 'projectNam').length === 1;
            const IS_CNY_SAME = _.uniqBy(this.selectedItems, 'cny').length === 1;
            const IS_INCOME_TYPE_SAME = _.uniqBy(this.selectedItems, 'incomeType').length === 1;
            const IS_SERVICE_TYPE_SAME = _.uniqBy(this.selectedItems, 'serviceType').length === 1;
            const HAS_PAYED = _.filter(this.selectedItems, (o) => o.status !== 1 && o.status !== 3).length > 0;
            return IS_PAYEE_SAME && IS_PROJECT_SAME && IS_CNY_SAME && IS_INCOME_TYPE_SAME && IS_SERVICE_TYPE_SAME && !HAS_PAYED;
        },
        isEnableBatchDelete() {
            if (this.selectedItems.length === 0) return false;

            // 全部都是待請款才能刪除
            const STATUS_NOT_PENDING_ITEMS = _.filter(this.selectedItems, (o) => o.status !== 3).length;

            return STATUS_NOT_PENDING_ITEMS === 0;
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            const SDT = +moment().startOf('year').format('x');
            const EDT = +moment().endOf('year').format('x');
            this.payDateRange = [SDT, EDT];

            await this.updateData(true);
            this.$store.dispatch('accounting/updateAccountingSettings');
        },
        async updateData(initPageNum) {
            if (initPageNum) this.queryParams.PageNum = 1;

            try {
                this.isLoading = true;
                const resp = await this.$api({
                    url: 'ServiceOrder/QueryServiceFeeStatement',
                    method: 'GET',
                    params: {
                        PayDatStart: this.payDateRange ? this.payDateRange[0] : null,
                        PayDatEnd: this.payDateRange ? this.payDateRange[1] : null,
                        ...this.queryParams,
                    },
                });
                this.datas = resp.data.items;

                this.amountStatistic = resp.data.amount;
                this.countStatistic = resp.data.count;

                this.totalDataCount = resp.data.totalNum;
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false;
            }
        },
        async deleteServiceFee(sno) {
            await this.$api({
                url: 'ServiceOrder/DeleteServiceFeeStatement',
                method: 'DELETE',
                data: { sno },
            });
        },
        onImport() {
            this.batchImportDialog.visible = true;
        },
        onAdd() {
            this.$router.push({ name: 'add-service-fee-statement' });
        },
        onSelectionChange(selections) {
            this.selectedItems = selections;
        },
        onEdit() {},

        onExportPdf() {
            const snoList = this.selectedItems.map((item) => item.sno);
            this.$refs.exportPdfDialog.setSnoList(snoList);
            this.exportPdfDialog.visible = true;
        },

        onTransform() {
            this.$router.push({
                name: 'transform-service-fee-statement',
                query: { list: _.map(this.selectedItems, 'sno').join(',') },
            });
        },

        onRowClick(row) {
            this.detailDialog.visible = true;
            this.detailDialog.sno = row.sno;
        },

        onDetailDialogClose(refresh) {
            this.detailDialog.visible = false;
            this.detailDialog.sno = null;
            if (refresh) this.updateData();
        },

        onChangeStatus(status) {
            this.queryParams.status = status;
            this.updateData(true);
        },

        getIncomeType(incomeType) {
            const FOUND = _.find(serviceTypeList, ['value', incomeType]);
            return FOUND?.type;
        },
        getServiceType(serviceType) {
            const FOUND = _.find([...serviceType9AList, ...serviceType9BList], ['key', serviceType]);
            if (FOUND) {
                return `${FOUND.key}：${FOUND.label}`;
            }
            return null;
        },
        onExportPdfDialogClose() {
            this.exportPdfDialog.visible = false;
        },
        onBatchImportDialogDialogClose() {
            this.batchImportDialog.visible = false;
        },
        async onBatchDelete() {
            try {
                const num = this.selectedItems.length;
                await this.$confirm(`確定要刪除已勾選的 ${num} 張勞報單？`, {
                    confirmButtonText: '確定刪除',
                    cancelButtonText: '取消',
                });
                this.isLoading = true;
                for (let i = 0; i < this.selectedItems.length; i += 1) {
                    // eslint-disable-next-line no-await-in-loop
                    await this.deleteServiceFee(this.selectedItems[i].sno);
                }
                this.updateData(false);
            } catch (e) {
                console.log(e);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vars.scss";

.service-fee-statement {
    .tool-block {
        .form {
            display: flex;
            > :not(:last-child) {
                margin-right: 15px;
            }
        }
        .export-tool-block > * {
            display: flex;
            align-items: center;
            &:first-child {
                margin-bottom: 10px;
            }
            .label {
                margin-right: 10px;
            }
        }
    }
}
</style>
